import React from "react";

const variants = {
  default: "badge-muted",
  success: "badge-success",
  warning: "badge-warning",
  danger: "badge-danger",
  premium: "badge-premium",
  info: "badge-info",
};

export default function StatusBadge({ variant = "default", children, icon: Icon, className = "", ...rest }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium tracking-wide ${variants[variant]} ${className}`}
      {...rest}
    >
      {Icon && <Icon size={11} weight="fill" />}
      {children}
    </span>
  );
}
